/**
 * The QA component library lives at an unlinked public path. Nothing in the app links to it; QA is
 * given the URL. index.html repeats this check inline (it cannot import modules) to keep trackers,
 * Maps and Stripe off the page — keep the two in step.
 */
export const UI_LIBRARY_PATH = "/ui-library";

export function isUiLibraryPath(pathname: string): boolean {
	return pathname === UI_LIBRARY_PATH || pathname === `${UI_LIBRARY_PATH}/`;
}
